import NotificationsAccessSchema, { NotificationsAccessParams, NotificationsAccessJSON } from "permissions/resources/notifications/notifications-permissions-resources-schema";
import { Resource } from "permissions/resources/permission-resource";
import { registerResource } from "permissions/resources/resource-registry";
import { AccessLevel, AnyResourceJSON, ResourceFromJSON, ResourceType, Scope } from "permissions/resources/permission-resource-types";

export class NotificationsAccess extends Resource {
  public static create(params?: NotificationsAccessParams): NotificationsAccess {
    const parsed = NotificationsAccessSchema.validate(params);
    return new NotificationsAccess(parsed);
  }

  public static fromJSON<J extends AnyResourceJSON>(json: J): ResourceFromJSON<J> {
    const parsed = NotificationsAccessSchema.deserialize(json as NotificationsAccessJSON);
    return new NotificationsAccess(parsed) as ResourceFromJSON<J>;
  }

  public static getPermutations(): NotificationsAccess[] {
    const fieldIterations: [key: string, value: number[]][] = [
      ['accessLevel', Object.values(AccessLevel).filter((key) => !Number.isNaN(Number(key))).map(value => Number(value))],
      ['scope', Object.values(Scope).filter((key) => !Number.isNaN(Number(key))).map(value => Number(value))],
    ];
    return this.generatePermutations(NotificationsAccess, fieldIterations) as NotificationsAccess[];
  }

  public readonly resourceType = ResourceType.NotificationsAccess;
  public readonly accessLevel?: AccessLevel;
  public readonly scope?: Scope;

  public constructor(params?: NotificationsAccessParams) {
    super(params);

    if (params) {
      this.accessLevel = params.accessLevel;
      this.scope = params.scope;
    }
  }

  public toJSON(): NotificationsAccessJSON {
    return NotificationsAccessSchema.serialize(this);
  }

  public override toString(): string {
    return `NotificationsAccess {
      resourceType: ${this.resourceType}
      isDisabled: ${this.isDisabled ? 'true' : 'false'}
      resourceTypeText: ${this.resourceTypeText}
      accessLevel: ${this.accessLevel}
      scope: ${this.scope}
    }`
  }
}

registerResource("NotificationsAccess", (json) => NotificationsAccess.fromJSON(json));
